// import { useGetBrandsQuery } from '../features/slice/products/brand/brand-api-slice';
// import { useGetGenericsQuery } from '../features/slice/products/generic/generic-api-slice';
// import { useGetStrengthQuery } from '../features/slice/products/strength/strength-api-slice';
// import { useGetTypesQuery } from '../features/slice/products/type/type-api-slice';
// import { useGetUnitsQuery } from '../features/slice/products/unit/unit-api-slice';
// import { useGetRoleQuery } from '../features/slice/users/roles.permission/role-permission-api-slice';
// import {
//   ProductBrandDto,
//   ProductGenericDto,
//   ProductStrengthDto,
//   ProductTypeDto,
//   ProductUnitDto,
// } from '../types/products';
// const useFetchFieldOptions: any = (fieldName: string) => {
//   let options = [];
//   const { data: brandsData } = useGetBrandsQuery('brands');
//   const { data: genericsData } = useGetGenericsQuery('generics');
//   const { data: typesData } = useGetTypesQuery('type');
//   const { data: strengthData } = useGetStrengthQuery('strength');
//   const { data: unitsData } = useGetUnitsQuery('unit');
//   const { data: rolesList } = useGetRoleQuery('roles');
//   switch (fieldName) {
//     case 'brand_id': {
//       options =
//         brandsData?.data.map((brand: ProductBrandDto) => ({
//           label: brand.name,
//           value: brand.id,
//         })) || [];
//       break;
//     }
//     case 'generic_id': {
//       options =
//         genericsData?.data.map((generic: ProductGenericDto) => ({
//           label: generic.name,
//           value: generic.id,
//         })) || [];
//       break;
//     }
//     case 'type_id': {
//       options =
//         typesData?.data?.map((type: ProductTypeDto) => ({
//           label: type.name,
//           value: type.id,
//         })) || [];
//       break;
//     }
//     case 'strength_id': {
//       options =
//         strengthData?.data?.map((strength: ProductStrengthDto) => ({
//           label: strength.name,
//           value: strength.id,
//         })) || [];
//       break;
//     }
//     case 'unit_id': {
//       options =
//         unitsData?.data?.map((unit: ProductUnitDto) => ({
//           label: unit.name,
//           value: unit.id,
//         })) || [];
//       break;
//     }
//     case 'role_id': {
//       options =
//         rolesList?.data?.map((role: { name: string; id: string }) => ({
//           label: role.name,
//           value: role.id,
//         })) || [];
//       break;
//     }
//     default:
//       break;
//   }
//   return options;
// };
// export default useFetchFieldOptions;
import { useMemo } from 'react';

import { useGetBrandsQuery } from '../features/slice/products/brand/brand-api-slice';
import { useGetGenericsQuery } from '../features/slice/products/generic/generic-api-slice';
import { useGetStrengthQuery } from '../features/slice/products/strength/strength-api-slice';
import { useGetTypesQuery } from '../features/slice/products/type/type-api-slice';
import { useGetUnitsQuery } from '../features/slice/products/unit/unit-api-slice';
import { useGetRoleQuery } from '../features/slice/users/roles.permission/role-permission-api-slice';
import {
  ProductBrandDto,
  ProductGenericDto,
  ProductStrengthDto,
  ProductTypeDto,
  ProductUnitDto,
} from '../types/products';

const useFetchFieldOptions = (
  fieldName: string,
): {
  label: string;
  value: string;
}[] => {
  const { data: brandsData } = useGetBrandsQuery({
    limit: 300,
    page: 1,
  });
  const { data: genericsData } = useGetGenericsQuery({
    limit: 300,
    page: 1,
  });
  const { data: typesData } = useGetTypesQuery({
    limit: 300,
    page: 1,
  });
  const { data: strengthData } = useGetStrengthQuery({
    limit: 300,
    page: 1,
  });
  const { data: unitsData } = useGetUnitsQuery({
    limit: 300,
    page: 1,
  });
  const { data: rolesList } = useGetRoleQuery({
    limit: 300,
    page: 1,
  });

  const options = useMemo(() => {
    switch (fieldName) {
      case 'brand_id':
        return (
          brandsData?.data?.map((brand: ProductBrandDto) => ({
            label: brand.name,
            value: brand.id,
          })) || []
        );
      case 'generic_id':
        return (
          genericsData?.data?.map((generic: ProductGenericDto) => ({
            label: generic.name,
            value: generic.id,
          })) || []
        );
      case 'type_id':
        return (
          typesData?.data?.map((type: ProductTypeDto) => ({
            label: type.name,
            value: type.id,
          })) || []
        );
      case 'strength_id':
        return (
          strengthData?.data?.map((strength: ProductStrengthDto) => ({
            label: strength.name,
            value: strength.id,
          })) || []
        );
      case 'unit_id':
        return (
          unitsData?.data?.map((unit: ProductUnitDto) => ({
            label: unit.name,
            value: unit.id,
          })) || []
        );
      case 'role_id':
        return (
          rolesList?.data?.map((role: any) => ({
            label: role.name,
            value: role.id,
          })) || []
        );
      default:
        return [];
    }
  }, [
    fieldName,
    brandsData,
    genericsData,
    typesData,
    strengthData,
    unitsData,
    rolesList,
  ]);

  return options;
};

export default useFetchFieldOptions;
